var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { jsx } from "react/jsx-runtime";
import "../../Styling.js";
import { MessageBar as MessageBar$1 } from "@fluentui/react/lib/MessageBar";
import { LABEL_CONSTANTS } from "../../constants/labels.constants.js";
import { getTheme, concatStyleSets, mergeStyles } from "@fluentui/style-utilities";
const defaultClassName = "ane-MessageBar";
const defaultMessageBarStyles = {
  root: {
    "p:last-child": {
      marginBottom: 0
    },
    "p:first-child": {
      marginTop: 0
    },
    selectors: {
      "& a": {
        color: getTheme().palette.themeDark,
        textDecoration: "underline"
      },
      "& .ms-Link": {
        textDecoration: "underline"
      }
    }
  }
};
const MessageBar = (props) => {
  const _a = props, { className, dismissButtonAriaLabel = LABEL_CONSTANTS.dismissLabel, styles } = _a, rest = __objRest(_a, ["className", "dismissButtonAriaLabel", "styles"]);
  return /* @__PURE__ */ jsx(
    MessageBar$1,
    __spreadProps(__spreadValues({
      dismissButtonAriaLabel,
      styles: concatStyleSets(defaultMessageBarStyles, styles)
    }, rest), {
      className: mergeStyles(defaultClassName, className)
    })
  );
};
export {
  MessageBar,
  MessageBar as default
};
//# sourceMappingURL=MessageBar.js.map
